// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import MainLayout from "./components/templates/MainLayout";
import AuthLayout from "./components/templates/AuthLayout";
import NoNavLayout from "./components/templates/NoNavLayout";
import SignInPage from "./components/pages/auth/SignInPage";
import SignUpPage from "./components/pages/auth/SignUpPage";
import PhoneOtpPage from "./components/pages/PhoneOtpPage";
import HomePage from "./components/pages/HomePage";
import PinDetailsPage from "./components/pages/map/PinDetailsPage";
import WatchPage from "./components/pages/watch/WatchPage";
import SeriesPage from "./components/pages/watch/SeriesPage";
import VideoPlayerPage from "./components/pages/watch/VideoPlayerPage";
import DropMessagePage from "./components/pages/message/DropMessagePage";
import TimeCapsuleWizard from "./components/pages/message/timecapsule/TimeCapsuleWizard";
import MessagesPage from "./components/pages/message/MessagesPage";
import ProfileSettingsPage from "./components/pages/profile/ProfileSettingsPage";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import AdminLayout from "./components/templates/AdminLayout";
import CMSDashboardPage from "./components/pages/admin/CMSDashboardPage";
import SeriesCreatePage from "./components/pages/admin/SeriesCreatePage";
import SeriesEditPage from "./components/pages/admin/SeriesEditPage";
import EpisodeCreatePage from "./components/pages/admin/EpisodeCreatePage";
import EpisodeEditPage from "./components/pages/admin/EpisodeEditPage";
import PublicTimeCapsuleCMSPage from "./components/pages/admin/PublicTimeCapsuleCMSPage";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route
          path="/admin/cms/"
          element={
            <AdminLayout>
              <CMSDashboardPage />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/cms/series/new"
          element={
            <AdminLayout>
              <SeriesCreatePage />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/cms/series/edit/:id"
          element={
            <AdminLayout>
              <SeriesEditPage />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/cms/episodes/new"
          element={
            <AdminLayout>
              <EpisodeCreatePage />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/cms/episodes/edit/:id"
          element={
            <AdminLayout>
              <EpisodeEditPage />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/cms/timecapsules"
          element={
            <AdminLayout>
              <PublicTimeCapsuleCMSPage />
            </AdminLayout>
          }
        />

        <Route
          path="/signin"
          element={
            <AuthLayout>
              <SignInPage />
            </AuthLayout>
          }
        />
        <Route
          path="/connect"
          element={
            <MainLayout>
              <SignInPage />
            </MainLayout>
          }
        />
        <Route
          path="/signup"
          element={
            <AuthLayout>
              <SignUpPage />
            </AuthLayout>
          }
        />
        <Route
          path="/phone-otp"
          element={
            <AuthLayout>
              <PhoneOtpPage />
            </AuthLayout>
          }
        />

        <Route
          path="/"
          element={
            <MainLayout>
              <HomePage />
            </MainLayout>
          }
        />

        <Route
          path="/capsule/:id"
          element={
            <MainLayout>
              <PinDetailsPage />
            </MainLayout>
          }
        />

        <Route
          path="/messages/drop"
          element={
            <MainLayout>
              <DropMessagePage />
            </MainLayout>
          }
        />
        <Route
          path="/messages"
          element={
            <ProtectedRoute>
              <MainLayout>
                <MessagesPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/timecapsule"
          element={
            <ProtectedRoute>
              <MainLayout>
                <TimeCapsuleWizard />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/watch"
          element={
            <MainLayout>
              <WatchPage />
            </MainLayout>
          }
        />
        <Route
          path="/series/:id"
          element={
            <MainLayout>
              <SeriesPage />
            </MainLayout>
          }
        />

        <Route
          path="/video/:episodeId"
          element={
            <NoNavLayout>
              <VideoPlayerPage />
            </NoNavLayout>
          }
        />

        <Route
          path="/profile/settings"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ProfileSettingsPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
